import { apiPost } from './client';

export interface Notification {
  id?: string;
  name?: string;
  text?: string;
  isViewed?: boolean;
  createdAt?: string;
  [key: string]: unknown;
}

export interface FindNotificationsParams {
  page?: number;
  itemsPerPage?: number;
  isViewed?: boolean;
}

export interface FindNotificationsResponse {
  items: Notification[];
  count: number;
}

export async function findNotifications(
  params: FindNotificationsParams = {},
): Promise<FindNotificationsResponse> {
  return apiPost<FindNotificationsResponse>('/api/notifications/find', {
    page: params.page ?? 1,
    itemsPerPage: params.itemsPerPage ?? 5,
    isViewed: params.isViewed ?? false,
  });
}
